import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { GetDocs, setEditDoc, TypeGetDocsR } from '../../store/officialDoc/actions';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { BasicDatePicker, SelectOutline } from '../ui';
import moment from 'moment';
import { EditNormativka } from './EditNormativka';
import { colorsStatus } from '../../utils/consts';
import { useSearchAny } from '../../hooks/useSearchAny';
import { IOfficialDoc } from '../../store/officialDoc/types';

interface Column {
  id: 'id' | 'name' | 'type' | 'approved' | 'docDate' | 'docNum' | 'update' | 'redactions' | 'delete' | 'edit';
  label: string;
  align?: 'right' | 'left' | 'center';
  width?: string;
  format?: (value: number) => string;
}

const columns: Column[] = [
  { id: 'id', label: 'ID', align: 'center', width: '5%' },
  { id: 'type', label: 'Назва', align: 'left' },
  { id: 'name', label: 'Тип', align: 'center', width: '10%' },
  { id: 'approved', label: 'Статус', align: 'center' },
  {
    id: 'docDate',
    label: 'Дата документа',
    align: 'center',
  },
  {
    id: 'docNum',
    label: 'Номер документа',
    align: 'center',
  },
  {
    id: 'update',
    label: 'Дата змін',
    align: 'center',
  },
  {
    id: 'edit',
    label: 'Документ',
    align: 'center',
    width: '15%',
  },
];

type PropsType = {};

export const ListNormativka: React.FC<PropsType> = () => {
  const [id, setId] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [type, setType] = React.useState('');
  const [dateDoc, setDateDoc] = React.useState<Date | null>(null);
  const [docNum, setDocNum] = React.useState('');

  const { OfficialDoc, Sidebar, Configurations } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const { loading, handleSearch } = useSearchAny({
    SearchData: GetDocs,
  });

  React.useEffect(() => {
    if (Sidebar.page.type === 'main' || Sidebar.page.type === 'list') {
      dispatch(setEditDoc(null));
    }
  }, [dispatch, Sidebar.page]);

  React.useEffect(() => {
    if (moment(dateDoc).isValid() || type) {
      const data = {} as TypeGetDocsR['data'];
      if (dateDoc) data['docDate'] = dateDoc;
      if (type) data['typeId'] = Number(type);
      if (title) data['title'] = title;
      if (docNum) data['docNum'] = docNum;

      dispatch(
        GetDocs.request({
          data: data,
        })
      );
    }
    // eslint-disable-next-line
  }, [dispatch, type, dateDoc]);

  const clearFiltres = () => {
    setId('');
    setTitle('');
    setType('');
    setDateDoc(null);
    setDocNum('');
    dispatch(GetDocs.request({ data: {} }));
  };

  if (OfficialDoc.editData && OfficialDoc.editData.data) {
    return (
      <EditNormativka
        data={OfficialDoc.editData.data as IOfficialDoc}
        handleCancel={() => dispatch(setEditDoc(null))}
      />
    );
  }

  return (
    <>
      <Box  style={{ display: 'flex', flexWrap: 'wrap' }}>
        <TextField
          size='small'
          id='outlined-basic-id'
          label='Пошук по ID'
          variant='outlined'
          value={id}
          onChange={(event: React.ChangeEvent<{ value: string }>) => {
            const num = event.target.value.replace(/[^0-9.]/g, '');
            setId(num);
            handleSearch(num, 'id');
          }}
        />
        <TextField
          
          size='small'
          id='outlined-basic-title'
          label='Назва'
          variant='outlined'
          value={title}
          onChange={(event: React.ChangeEvent<{ value: string }>) => {
            const data: any = {};
            if (dateDoc) data['docDate'] = dateDoc;
            if (type) data['typeId'] = Number(type);
            if (docNum) data['docNum'] = docNum;
            setTitle(event.target.value);
            handleSearch(event.target.value, 'title', data);
          }}
        />
        <SelectOutline
          style={{ width: '210px' }}
          id='outlined-basic-type'
          title='Тип документа'
          value={type}
          
          options={
            Configurations.configurations?.typesDoc.map((it) => ({ value: String(it.id), label: it.name })) || []
          }
          handleChange={(value) => {
            setType(value);
          }}
        />
        <div  style={{ width: '210px' }}>
          <BasicDatePicker
            label='Дата документа'
            value={dateDoc}
            onChange={(value) => {
              setDateDoc(value);
            }}
          />
        </div>
        <TextField
          
          size='small'
          id='outlined-basic-title'
          label='Номер'
          variant='outlined'
          value={docNum}
          onChange={(event: React.ChangeEvent<{ value: string }>) => {
            const data: any = {};
            if (dateDoc) data['docDate'] = dateDoc;
            if (type) data['typeId'] = Number(type);
            if (docNum) data['title'] = title;
            setDocNum(event.target.value);
            handleSearch(event.target.value, 'docNum', data);
          }}
        />
        <Button  variant='contained' color='primary' onClick={clearFiltres}>
          Очистити фільтри
        </Button>
        {OfficialDoc.loading || loading ? <CircularProgress size={25} /> : null}
      </Box>
      <TableContainer  style={{ maxHeight: 'calc(100vh - 295px)' }}>
        <Table  stickyHeader aria-label='sticky table'>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} style={{ width: column?.width || '' }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {OfficialDoc.data?.officialDoc?.map((row, i) => {
              return (
                <TableRow style={{ maxHeight: 50 }} hover role='checkbox' tabIndex={-1} key={`${i}-${row.id}`}>
                  <TableCell align='center'>{row.id}</TableCell>
                  <TableCell >{row.title}</TableCell>
                  <TableCell  align='center'>
                    {row.type}
                  </TableCell>
                  <TableCell  align='center' style={{ color: colorsStatus[row.approved] }}>
                    {OfficialDoc.status.approved[row.approved]}
                  </TableCell>
                  <TableCell  align='center'>
                    {moment(row.docDate).format('DD.MM.YYYY HH:mm')}
                  </TableCell>
                  <TableCell  align='center'>
                    {row.docNum}
                  </TableCell>
                  <TableCell  align='center'>
                    {moment(row.update).format('DD.MM.YYYY HH:mm')}
                  </TableCell>
                  <TableCell align='center'>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={() => dispatch(setEditDoc({ type: 'edit', data: row }))}
                    >
                      Переглянути
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
